export default __webpack_public_path__ + "static/media/M2HairSalon-1.e9e9ff1a.jpg";